/**
 * User Model
 */
class User {
  constructor(model, token, account) {
    const convertedUserModel = User.convertUserDTOtoModel(model);
    
    this.token = token;
    this.account = account;
    this.sub = convertedUserModel.sub;
    this.name = convertedUserModel.name;
    this.email = convertedUserModel.email;
    this.lastName = convertedUserModel.lastName;
    this.avatarUrl = convertedUserModel.avatarUrl;
    this.firstName = convertedUserModel.firstName;
    this.isEmailVerified = convertedUserModel.isEmailVerified;
    this.nameInitials = `${this.firstName.charAt(0)}${this.lastName.charAt(0)}`;
  }

  static convertUserDTOtoModel = ({
    sub,
    name,
    email,
    lastname,
    firstname,
    picture_url,
    email_verified
  }) => ({
    sub,
    name,
    email,
    lastName: lastname,
    firstName: firstname,
    avatarUrl: picture_url,
    isEmailVerified: email_verified
  });
}
export default User;
